import { render, staticRenderFns } from "./ChainBPBarHeadBlock.vue?vue&type=template&id=ae777dc0"
import script from "./ChainBPBarHeadBlock.vue?vue&type=script&lang=js"
export * from "./ChainBPBarHeadBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports